

import React, { useEffect, useState } from 'react';
import "./Increment_Decrement_Btn.css";
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFortAwesome } from '@fortawesome/free-brands-svg-icons';
import { getAllCart, postCartQuantity } from '../../../../features/cart/cartSlice';
import { useDispatch } from 'react-redux';

const IncrementDecrementBtn = ({ isSignIn, setaddCartBTNShow, productId, cart, product, setQuantity, quantity, restaurant }) => {
    const [count, setCount] = useState(1); // State to hold the count

    const [newcart, setNewCart] = useState();
    const [Errors, setErrors] = useState();
    const dispatch = useDispatch();
    const handleIncrement = () => {
        setQuantity((prevCount) => prevCount + 1); // Increment the count
    };

    const handleDecrement = () => {
        setQuantity((prevCount) => (prevCount > 0 ? prevCount - 1 : 0)); // Decrement the count but not below 0
    };

    const mainClassName = `main_content_holder ${restaurant ? 'restaurant' : ''}`;

    const cartQuantity = async (type) => {
        try {

            const data = {
                cart_id: newcart?.id,
                type: type,
                Product: product,
                isSignIn,
                product_id: cart.product_id || product?.id,
                // variant_id: cart.variant_id || product,
            };

            // console.log({ cartQuantity_data: data });

            const res = await dispatch(postCartQuantity(data));
            if (res.meta?.requestStatus === "fulfilled") {
                await dispatch(getAllCart(isSignIn));
                setaddCartBTNShow(false)
            } else if (res.meta?.requestStatus === "rejected") {
                console.log("Error:", res.payload || "Not In Cart");
            }
        } catch (error) {
            console.log("Error:", error);
        }
    };

    useEffect(() => {
        if (cart?.length > 0) {
            for (const item of cart) {
                if (item?.product_id === productId) {
                    setNewCart(item);
                }
            }
        }
    }, [cart]);

    // console.log({ newcart_newcart: newcart });
    // console.log({ cart_cart: cart });


    return (
        <div className='Increment_Decrement_Btn'>
            <div className={mainClassName}>
                {/* Decrement Button */}
                <div className='icon_holder' onClick={() => {
                    cartQuantity("minus");
                }}>
                    {cart?.quantity == 1 ? (
                        <FontAwesomeIcon icon={faTrashAlt} className="icon_class" />
                    ) : (
                        <FontAwesomeIcon icon={faMinus} className="icon_class" />
                    )}
                    {/* <FontAwesomeIcon icon={faTrashAlt} className='icon_class' /> */}
                </div>
                {/* Count Display */}
                <div className='count_holder'>
                    <p className='count'>{newcart?.quantity}</p>
                </div>
                {/* Increment Button */}
                <div className='icon_holder' onClick={() => {
                    cartQuantity("add");
                }}>
                    <FontAwesomeIcon icon={faPlus} className='icon_class' />
                </div>
            </div>
        </div>
    );
};

export default IncrementDecrementBtn;
